<template>
  <div class="task-status">
    <div class="task-status__heading">{{ $t('approvals.STATUS') }}</div>
    <div class="task-status__right">
      <BaseTooltip v-if="props.isRejected">
        <template #trigger>
          <BaseChip theme="red-alert">
            <template #icon>
              <ExitIcon />
            </template>
            {{ $t('approvals.REJECTED') }}
          </BaseChip>
        </template>
        <template #content>{{ $t('approvals.REJECTED_INFO') }}</template>
      </BaseTooltip>

      <BaseTooltip v-else-if="props.isDone">
        <template #trigger>
          <BaseChip theme="new-leaf">
            <template #icon>
              <CheckmarkIcon />
            </template>
            {{ $t('approvals.COMPLETED') }}
          </BaseChip>
        </template>
        <template #content>{{ $t('approvals.COMPLETED_INFO') }}</template>
      </BaseTooltip>

      <BaseTooltip v-else>
        <template #trigger>
          <BaseChip>{{ $t('approvals.NOT_COMPLETED') }}</BaseChip>
        </template>
        <template #content>{{ $t('approvals.NOT_COMPLETED_INFO') }}</template>
      </BaseTooltip>

      <BaseButton
        v-if="showRejectButton"
        size="small"
        outline
        @click="openRejectModal"
      >
        {{ $t('approvals.REJECT').toString() }}
      </BaseButton>
    </div>

    <UserTaskRejectModal
      v-if="isRejectModalOpen"
      :product-id="productId"
      :user-id="userId"
      :activity-item-user-id="activityItemUserId"
      @close="closeRejectModal"
    />
  </div>
</template>

<script lang="ts" setup>
import BaseButton from '@/components/generics/base/BaseButton.vue'
import BaseChip from '@/components/generics/base/BaseChip.vue'
import BaseTooltip from '@/components/generics/base/BaseTooltip.vue'
import CheckmarkIcon from '@/components/icon_components/CheckmarkIcon.vue'
import ExitIcon from '@/components/icon_components/ExitIcon.vue'
import { useDialog } from '@/hooks/useDialog'
import { computed, defineProps } from 'vue'
import UserTaskRejectModal from './UserTaskRejectModal.vue'

const props = defineProps<{
  isDone: boolean
  isRejected: boolean
  isCertified: boolean
  productId: string
  userId: string
  activityItemUserId: string
}>()

const {
  isOpen: isRejectModalOpen,
  openDialog: openRejectModal,
  closeDialog: closeRejectModal,
} = useDialog()

const showRejectButton = computed(() => {
  return props.isDone && !props.isCertified
})
</script>

<style lang="scss" scoped>
.task-status {
  @include cardStyle;
  display: flex;

  gap: $spacing-2xs;
  border: none;
  flex-direction: column;
  padding: $spacing-xs;
  background: $color-paper;

  &__heading {
    @include subtitle-2;
    font-weight: 700;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: $spacing-3xs;
  }
}
</style>
